import React from 'react'
import styled from 'styled-components'
import media from 'styled-media-query'
import Section from '../../atoms/Section/Section'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import NavMarkers from '../StickyBar/NavMarkers'

const Style = styled.div`

  #certificate{
    padding-left: 0;
    padding-right: 0;
    ${media.lessThan('769px')`
      margin-left: 0;
      margin-right: 0;
    `}
  }
  .slick-slide {
     div {
      display: flex;
    }
  }

.slick-carousel{

  max-width:900px;
  margin-left:8px;
  margin-right:8px;
  ${media.lessThan('medium')`
  max-width:100vw;
  display: flex;
  justify-content: center;
  margin-right: 0px;
  margin-left: 0px;
  min-width: 50%;
  `}
}
${media.between('769px', '947px')`
  width: auto;
  margin-right: 16px;
  margin-left: 16px;

  `}

  flex-direction: column;
  ${media.greaterThan('medium')`
  border: 1px solid #E1E7EF;
  border-radius: 16px;
  `}
  margin-top: 30px;
  max-width: 915px;
  margin: 30px auto 77px;
  height: auto;
  background-color: #F8F9FB;
  display: flex;
  padding: 56px 57.5px 66px;
  ${media.lessThan('medium')`
    width: 100%;
    height: auto;
    padding: 32px 16px 18px 16px;
  `}
  ${media.lessThan('886px')`
    padding: 32px 16px 32px 16px;
  `}
  .title {
    margin-bottom: 32px;
    color: #162941;
    ${media.lessThan('medium')`
      margin-bottom: 28px;
    `}
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 33px;
    margin-right: auto;
    margin-left: auto;
  }
  .description {
    margin-bottom: 64px;
    ${media.lessThan('medium')`
      margin-bottom: 40px;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 25.2px;
      text-align: center;
      `}
    color: #162941;
    font-size: 18px;
    max-width: 672px;
    margin-right: auto;
    margin-left: auto;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-align: center;
  }
  .images-container{
    display: flex;
    justify-content: center;
    & div {
      margin: 0 5px;
    }

  }
  .slider-container{
      ${media.lessThan('450px')`
      justify-content:between;
      display:flex; 
      `}
      ${media.lessThan('390px')`
      justify-content:between;
      display:flex;
      `}
  }
  .slider-images-container {

    width: ${(props) =>
      props.count === 1
        ? '200px'
        : props.count === 2
        ? '400px'
        : props.count === 3
        ? '600px'
        : props.count === 4
        ? '200%'
        : '200%'};
     margin: auto;
     ${media.lessThan('medium')`
     width: 100% !important;
     max-width: 100%;
     display: flex;
     justify-content: center;
     align-items: center;
   `}
  }
  .flex-slider-images-container{

  }
  .more {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 140%;
    text-align: center;
    color: #000000;
    ${media.lessThan('medium')`
    font-size: 14px;
    `}
  }
  .slick-slide div:first-child{
    display: flex;
  }
  .verify {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    width: 147px;
    height: 42px;
    background: #31279B;
    border-radius: 6px;
    color: white;
    margin: 0 auto;
    text-decoration: none;
  }
  .insurance-images {
    max-width: 164px;
    ${media.lessThan('886px')`
    max-width: 15vw;
    
    `}
    ${media.lessThan('450px')`
    max-width: 103px;
    
    `}
  }
  #flex-image-container{
    width: 188px;
    height: 142px;
    background: #ffffff;
    border: 0.802646px solid #e1e7ef;
    border-radius: 12.8423px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${media.lessThan('949px')`
    width: 170px;
    height: 142px;
    
    `}
    ${media.lessThan('medium')`
    width: 150px;
    height: 142px;
    
    `}
  }
  #image-container {

    min-height: 142px;
    ${media.lessThan('medium')`
    height: 100px;
    min-height: 100px;
    max-height: 100px;
    min-width: calc(100% - 16px);
  `}
  ${media.between('887px', '935px')`
  max-width: 170px;
  min-width: 170px;
  `}
  
  ${media.lessThan('886px')`
  height: 120px;
  min-height: 142px;
  
    min-width: 100px;
    margin-top: 12px;
    `}
    
    ${media.lessThan('450px')`
    max-height: 142px;
    margin-top: 14px;
    height: 111px;
    min-height: 142px;
    max-width: calc(100% - 16px);
    display: flex;
    justify-content: center;
    `}

    ${media.lessThan('medium')`
    max-width: calc(100% - 16px);
    `}
    ${media.lessThan('394px')`
    max-height: 111px;
    margin-top: 14px;
    height: 111px;
    min-height: 170px;
    display: flex;
    justify-content: center;
    `}

    ${media.lessThan('390px')`
    max-height: 111px;
    margin-top: 14px;
    height: 111px;
    min-height: 170px;
    display: flex;
    justify-content: center;
    `}
    background: #ffffff;
    border: 0.802646px solid #e1e7ef;
    border-radius: 12.8423px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .button-container{
    margin-top 115px;
    ${media.lessThan('medium')`
    margin-top 96px;
    `}
  }
  .slick-dots {
    bottom: -40px;
    height:24px;
    margin: 0;
    ${media.lessThan('medium')`
    bottom: -32px;
    
    `}
  }
 
  .slick-dots li.slick-active button:before{
    font-size: 12px;
  }
  .slick-dots li button:before {
    font-size: 8px;

  }
  .grid{
    display: grid;
    gap: 16px;
    grid-template-columns: auto auto ;
  }
  max-width: 915px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;

  h3 {
    font-size: 24px;
    color: #000000;
  }
  p {
    max-width: 740px;
    margin: 0 auto;
    font-size: 21px;
    color: #2f2f2f;
    letter-spacing: 0.47px;
    line-height: 38px;
  }
  .certs {
    display: flex;
    max-width: 800px;
    margin: 0 auto;
    justify-content: space-around;
    p {
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 13px;
      margin-top: 7px;
    }

    img {
      @media (min-width: 600px) {
        max-height: 90px;
      }
      @media (max-width: 600px) {
        max-width: 100%;
      }
    }
  }
  .flex-certs {
    display: flex;
    max-width: 800px;
    margin: 0 auto;
    justify-content: space-between;
    p {
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 13px;
      margin-top: 7px;
    }

    img {
      @media (min-width: 600px) {
        max-height: 90px;
      }
      @media (max-width: 600px) {
        max-width: 100%;
      }
    }
  }
  .banner{
    background-color: #F8F9FB;
    padding-top: 0;
    padding-bottom: 0;
    max-width: 100%;
    ${media.greaterThan('medium')`
      padding-right: 0px;
      padding-left: 0px;
      margin-right: 0px;
      margin-left: 0px;
    `}
    ${media.lessThan('medium')`
    
    padding-bottom: 16px;
    margin-left: 0;
    margin-right: 0;
    padding-right: 0;
    padding-left: 0;
    padding-top: 0;


  `}
  ${media.lessThan('450px')`
  max-height:830px;
  `}
  }
  .disclaimerMultipleTiles {
    ${media.lessThan('786px')`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
   
  `}
  }
  .disclaimerTwoTiles {
    ${media.lessThan('786px')`
    margin-top: 388px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
   
  `}
  }

  .disclaimerOneTile {
    ${media.lessThan('786px')`
    margin-top:-382px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
   
  `}
  }

  .disclaimerMultipleTilesChildBlock{
    font-size: 12px;
    color: #677D95;
    margin-top: 62px;
    width: 400px;
    letter-spacing: 0.5px;
    text-align: center;
    margin-right: auto;
    margin-left: auto;
    line-height: 15px;
    max-width: 400px;
    ${media.lessThan('medium')`
    width: auto;
      margin-top: ${(prop) => (prop.dot ? '56px' : '48px')};
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      line-height: 15px;
    `}
    ${media.lessThan('small')`
      margin-top: ${(prop) => (prop.dot ? '56px' : '48px')};
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      line-height: 15px;
  `}
  }
  .disclaimerOneTileChildBlock{
    font-size: 12px;
    color: #677D95;
    margin-top: 64px;
    width:400px;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 15px;
    ${media.lessThan('medium')`
      width: auto;
      margin-top: 450px;
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      line-height: 15px;
    `}
    ${media.lessThan('small')`
      margin-top: 12px;
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      line-height: 15px;
  `}
  }
  .disclaimerTwoTilesChildBlock{
    font-size: 12px;
    color: #677D95;
    margin-top: 64px;
    width:400px;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 15px;
    ${media.lessThan('medium')`
      margin-top: 450px;
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      margin-left:-2px;
      line-height: 15px;
    `}
    ${media.lessThan('small')`
      margin-top: 270px;
      font-size: 12px;
      color: #677D95;
      font-weight: 400;
      line-height: 15px;
  `}
  }
  .header p{
    height: 54px;
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 54px;
    color: #162941;
    text-align: center;
    ${media.lessThan('medium')`
      height: 34px;  
      font-style: normal;
      font-weight: 600;
      font-size: 28px;
      line-height: 120%;
      color: #162941;  
  `}
  }
  
  .verifiedText p{
    max-width: 642px;
    margin-top: 40px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    color: #162941;
    ${media.lessThan('medium')`
    margin-top: 32px;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 140%;
      text-align: center;
      color: #162941;
  `}
  }
  .carousel-container{
    margin-top 64px;
    ${media.lessThan('medium')`
      margin-top: 40px;
    `}
  }
  .top-container-slider{
    max-width: 800px;
    display: flex;
    justify-content: center;
    ${media.lessThan('medium')`
      max-width: 100%;
    `}
  }
  .flex-top-container-slider{
    max-width: 800px;
    display: flex;
    justify-content: center;
    gap: 16px;
    ${media.lessThan('medium')`
      max-width: 100%;
      display: ${(prop) => (prop.singleCertificate ? 'flex' : 'grid')};
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-auto-flow: row;
      column-gap: 16px;
      row-gap: 0;

    `}
  }
`
const VerifiedInfo = ({ title, certs, description }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    centerPadding: '160px',
    className: 'slick-carousel',
    slidesToScroll: 4,
    slidesToShow: 4,
    rows: 1,
    slidesPerRow: 1,
    center: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesPerRow: 2,
          slidesToShow: 1,
          className: 'slick-carousel',
          slidesToScroll: 1,
          rows: certs.length > 2 ? 2 : 2
        }
      }
    ]
  }

  return (
    <Style
      id="certificate"
      dot={certs.length > 4}
      singleCertificate={certs.length < 2}
    >
      <NavMarkers id="certificates">
        <Section className="banner">
          <div className="header">
            <p>Verified by Recovery.com</p>
          </div>
          <div className="verifiedText">
            <p>
              Our research team verified that the name, location, contact
              information and license to operate for this treatment provider are
              valid and up-to-date. {title} has verified the information on this
              page to be accurate.
            </p>
          </div>
          <div className="carousel-container">
            {certs.length > 4 ? (
              <div>
                <div className="certs">
                  <div
                    className="slider-images-container"
                    style={{ justifyContent: 'center', display: 'flex' }}
                  >
                    <div className="top-container-slider">
                      <Slider {...settings}>
                        {certs?.map((cert) => (
                          <div
                            className="slick-carousel"
                            key={cert.label}
                          >
                            <div
                              id="image-container"
                              style={{
                                display: 'block',
                                padding: '20px 8px 0 8px',
                                margin: 'auto auto 16px'
                              }}
                            >
                              <img
                                style={{
                                  maxHeight: '72px',
                                  maxWidth: '124px'
                                }}
                                src={cert.image || cert.url}
                              />
                              <p
                                style={{
                                  fontSize: '12px',
                                  color: '#4D657F',
                                  fontWeight: 400,
                                  marginTop: '16px'
                                }}
                              >
                                {cert.label}
                              </p>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="certs">
                  <div className="slider-images-container">
                    <div className="flex-top-container-slider">
                      {certs?.map((cert) => (
                        <div
                          id="flex-image-container"
                          style={{
                            display: 'block',
                            padding: '20px 8px 0 8px',
                            margin: 'auto 0 16px 0'
                          }}
                          key={cert.label}
                        >
                          <img
                            style={{
                              maxHeight: '72px',
                              maxWidth: '124px'
                            }}
                            src={cert.image || cert.url}
                          />
                          <p
                            style={{
                              fontSize: '12px',
                              color: '#4D657F',
                              fontWeight: 400,
                              marginTop: '16px'
                            }}
                          >
                            {cert.label}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="disclaimerMultipleTiles">
              <p className="disclaimerMultipleTilesChildBlock">
                Recovery.com is an independent, third-party mental health
                resource. Verification does not imply endorsement and does not
                guarantee the quality of treatment services{' '}
              </p>
            </div>
          </div>
        </Section>
      </NavMarkers>
    </Style>
  )
}
export default VerifiedInfo
